import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * StepIndicator - Navigation for multi-step wizard
 *
 * Steps 1-6: Always clickable (can jump anywhere)
 * Step 7 (Recommendation): Only clickable after recommendation is generated
 */
const StepIndicator = ({ currentStep, steps, onStepClick, recommendationReady }) => {

  const handleClick = (stepNumber) => {
    // Step 7 only clickable if recommendation has been generated
    if (stepNumber === 7 && !recommendationReady) {
      return;
    }

    if (onStepClick) {
      onStepClick(stepNumber);
    }
  };

  return (
      <div className="step-indicator">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isActive = stepNumber === currentStep;

          // Step 7 only clickable if recommendation ready
          const isClickable = stepNumber < 7 || recommendationReady;

          return (
              <React.Fragment key={step.id}>
                <div
                    className={`step ${isClickable ? 'clickable' : ''}`}
                    onClick={() => handleClick(stepNumber)}
                    style={{ cursor: isClickable ? 'pointer' : 'not-allowed' }}
                    title={isClickable ? `Go to ${step.label}` : 'Complete Risk Assessment first'}
                >
                  <div className={`step-number ${isCompleted ? 'completed' : isActive ? 'active' : ''}`}>
                    {isCompleted ? (
                        <FontAwesomeIcon icon="check" />
                    ) : (
                        <FontAwesomeIcon icon={step.icon} />
                    )}
                  </div>
                  <span className={`step-label d-none d-md-inline ${isActive ? 'active' : ''}`}>
                {step.label}
              </span>
                </div>
                {index < steps.length - 1 && (
                    <div className={`step-connector ${isCompleted ? 'completed' : ''}`} />
                )}
              </React.Fragment>
          );
        })}
      </div>
  );
};

export default StepIndicator;